var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"systembody",staticStyle:{"background-color":"#f5f7fa"}},[_c('nav-bar'),_c('UsersList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }